/** A token package that customers can request a quote for or purchase */

/** List of the transaction sources, From which application a request has been mane to create a a transaction */
export let TransactionSources = /*#__PURE__*/function (TransactionSources) {
  TransactionSources["sphereDashboard"] = "SphereDashboard";
  TransactionSources["webEditor"] = "WebEditor";
  TransactionSources["sphereViewer"] = "SphereViewer";
  TransactionSources["coreApi"] = "core-api";
  return TransactionSources;
}({});

/** Information about a transaction source application */

/** List of transaction type */
export let TransactionTypes = /*#__PURE__*/function (TransactionTypes) {
  /** Transaction action type related to token consumption  */
  TransactionTypes["consumeTokens"] = "ConsumeTokens";
  /** Transaction action type related to token insertion by purchasing or from admin panel */
  TransactionTypes["insertTokens"] = "InsertTokens";
  /** Action types for expired token transactions */
  TransactionTypes["expireTokens"] = "ExpireTokens";
  /** Action types of activity when a subscription with tokens is created */
  TransactionTypes["createTokens"] = "CreateTokens";
  /** Action types of activity when a subscription with tokens is activated */
  TransactionTypes["activateTokens"] = "ActivateTokens";
  return TransactionTypes;
}({});

/** All the types of transaction result */

/** List of reasons for credit consumption */
export let ConsumptionReason = /*#__PURE__*/function (ConsumptionReason) {
  ConsumptionReason["floorplanGeneration"] = "floorplan-generator";
  return ConsumptionReason;
}({});

/** The action for the credit transaction when tokens are inserted */

/** The action for the credit transaction when tokens are created */

/** The action for the credit transaction when tokens are activated */

/** The action for the credit transaction when tokens are consumed */

/** The action for the credit transaction when tokens are expired */

/** Information about a transaction action, Purpose of the transaction */

/** Additional information about a transaction */

/** The base data for the result of a credit transaction */

/** The result of a credit transaction when tokens are inserted */

/** The result of a credit transaction when token insertion are rejected */

/** The result of a credit transaction when token insertion failed */

/** The result of a credit transaction when a tokens subscription is created */

/** The result of a credit transaction when a tokens subscription is activated */

/** The result of a credit transaction when tokens are consumed */

/** The result of a credit transaction when token consumption is rejected */

/** The result of a credit transaction when token consumption failed */

/** The result of a credit transaction when tokens are expired */

/** Information that all type of transaction has */

/** Information about transactions which are related to token addition */

/** Information about transactions which are related to tokens subscription creation */

/** Information about transactions which are related to tokens subscription activation */

/** Information about transactions which are related to token consumption */

/** Information about transactions which are related to token expiration */

/** Information about all transactions type */

/** The available view modes for the credit dialog. */
export let CreditViewMode = /*#__PURE__*/function (CreditViewMode) {
  CreditViewMode["transaction"] = "Transactions";
  CreditViewMode["purchases"] = "Purchases";
  return CreditViewMode;
}({});
export let CreditSubscriptionStatus = /*#__PURE__*/function (CreditSubscriptionStatus) {
  /** Means the credits remaining are the same as the purchased credits */
  CreditSubscriptionStatus["active"] = "Active";
  /** Means the credits remaining are more than 0 but less than the purchased credits */
  CreditSubscriptionStatus["activeInUse"] = "Active - In Use";
  /** The expiration date is later than the current date but the credits remaining is 0 */
  CreditSubscriptionStatus["used"] = "Used";
  /** The expiration date is later than the current date */
  CreditSubscriptionStatus["expired"] = "Expired";
  return CreditSubscriptionStatus;
}({});